import PropTypes from 'prop-types';

export default function OutlineDocs(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M1.5 3h5a3.333 3.333 0 0 1 3.333 3.333V18a2.5 2.5 0 0 0-2.5-2.5H1.5V3ZM18.167 3h-5a3.333 3.333 0 0 0-3.333 3.333V18a2.5 2.5 0 0 1 2.5-2.5h5.833V3Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineDocs.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
